import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import EmailIcon from "@mui/icons-material/Email";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  FormControlLabel,
  Link,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import PolicyHistory from "../../../../../Components/Broker/PolicyHistory/PolicyHistory";
import SelectvoluntryPlans from "../../../../../Components/Broker/SelectVoluntryPlans/SelectVoluntryPlans";
import BulkUploadForm from "../../../../../Components/Common/BulkUploadFormSP/BulkUploadForm";
import PostQueryForm from "../../../../../Components/Common/PostQuerySP/PostQueryForm";
import DatePicker from "../../../../../Supporting files/DatePicker/DatePicker";
import MultipleSearchDropdown from "../../../../../Supporting files/MultipleSearchDropdown/MultipleSearchDropdown";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import UGEmailInput from "../../../../../Supporting files/UGEmailInput/UGEmailInput";
import Exclusion from "../../Quotes/Exclusion/Exclusion";
import SelectFeature from "../../Quotes/SelectFeature/SelectFeature";

function AddNewPolicy() {
  const navigate = useNavigate();
  const [productType, setProductType] = useState<
    "Health" | "SuperTopup" | "Term"
  >("Term");
  const [ageBandData, setAgeBandData] = useState<
    Array<{ min_age: string; max_age: string }>
  >([{ min_age: "", max_age: "" }]);
  const [notesData, setNotesData] = useState<
    Array<{ name: string; date: Date; description: string }>
  >([]);
  const [sectionStatus, SetSectionStatus] =
    React.useState<string>("personalDetails");
  const [subSection, setSubSection] = React.useState("businesscard");
  const [organizationName, setOrganizationName] = React.useState("");
  const [ownership, setOwnership] = React.useState("");
  const [corporateAmount, setCorporateAmount] = React.useState("");
  const [planType, setPlanType] = React.useState(0);
  const [policyType, setPolicyType] = React.useState(0);
  const [familyDefinition, setFamilyDefinition] = React.useState(
    "Employee, Spouse & 2 dependant Children up to the age of 25 years"
  );
  const [familyDefinitionTerm, setFamilyDefinitionTerm] =
    React.useState("Employee");
  const [industry, setIndustry] = React.useState("");

  const [subIndustry, setSubIndustry] = React.useState("");
  const [totalNoOfLives, setTotalNoOfLives] = React.useState("");
  const [spoc, setSpoc] = React.useState("");
  const [sumInsuredOne, setSumInsuredOne] = React.useState("");
  const [attachment, setAttachment] = React.useState(false);
  const [uploadFile, setUploadFile] = React.useState(false);
  const [clientID, setClientID] = React.useState("");
  const [toggle, setToggle] = React.useState(true);
  const [show, setShow] = useState(false);
  const [showNominee, setShowNominee] = useState(false);
  const [enrolmentPeriod, setEnrolmentPeriod] = React.useState("");
  const [locations, setLocations] = React.useState("");
  const [kids, setKids] = React.useState("");
  const [employees, setEmployees] = React.useState("");
  const [showhealth, setShowhealth] = useState(false);
  const [spouse, setSpouse] = React.useState("");
  const [othersGraded, setOthersGraded] = React.useState("");
  const [totalKids, setTotalKids] = React.useState("");
  const [insurerOne, setInsurerOne] = React.useState("");
  const [emailcomp, setEmailComp] = React.useState(false);
  const [netpremium, setNetPremium] = React.useState("");
  const [tax, setTax] = React.useState("");
  const [showcorporate, setShowcorporate] = useState(false);
  const [showEnableRiders, setShowEnableRiders] = useState(false);
  const [cardType, setCardType] = React.useState("");
  const [healthcardIssued, setHealthCardIssued] = React.useState("");
  const [corporatebufferValue, setCorporateBufferValue] = React.useState("");
  const [grosspremium, setGrossPremium] = React.useState("");
  const [insurerOffice, setInsurerOffice] = React.useState("");
  const [insurerFour, setInsurerFour] = React.useState("");
  const [postQueryForm, setPostQueryForm] = React.useState(false);
  const [basicConfiguration, setBasicConfiguration] = React.useState("");
  const [basicConfigurationTerm, setBasicConfigurationTerm] =
    React.useState("1E");
  const [indvConfiguration, setIndvConfiguration] = React.useState("");
  const [addPremium, setAddPremium] = React.useState(false);
  const [contactNumber, setContactNumber] = React.useState("");
  const [enrollPeriod, setEnrollPeriod] = React.useState("");
  const [minAge, setMinAge] = React.useState("");
  const [maxAge, setMaxAge] = React.useState("");
  const [employeeenrollmentPeriod, setEmployeeEnrollmentPeriod] =
    React.useState("");
  const [maximunMembers, setMaximunMembers] = React.useState("");
  const [totalNumbers, setTotalNumbers] = React.useState("");
  const [organizationEmail, setOrganizationEmail] = React.useState("");
  const [addFeature, setAddFeature] = React.useState(false);
  const [selectvoluntryPlans, setSelectVoluntryPlans] = React.useState(false);
  const [Addexclusion, setAddExclusion] = React.useState(false);
  const [exclusion, setExclusion] = React.useState(false);
  const [websiteURL, setWebsiteURL] = React.useState("");
  const [gracePeriod, setGracePeriod] = React.useState("");
  const [maximumNominee, setMaximumNominee] = React.useState("");
  const [employeeAge, setEmployeeAge] = React.useState("");
  const [spouseAge, setSpouseAge] = React.useState("");
  const [sonAge, setSonAge] = React.useState("");
  const [daughterAge, setDaughterAge] = React.useState("");
  const [cDBalance, setCDBalance] = React.useState("");
  const [cDBalancePercent, setCDBalancePercent] = React.useState("");
  const [employeePayment, setEmployeePayment] = React.useState("%");
  const [spousePayment, setSpousePayment] = React.useState("%");
  const [childrenPayment, setChildrenPayment] = React.useState("%");
  const [parentsPayment, setParentsPayment] = React.useState("%");
  const [parentsinLawPayment, setParentsInLawPayment] = React.useState("%");
  const [salaryBracket, setSalaryBracket] = React.useState("");
  const [designationOne, setDesignationOne] = React.useState("");
  const [departmentOne, setDepartmentOne] = React.useState("");
  const [expanded, setExpanded] = React.useState<string | false>("panel");
  const [startDate, setStartDate] = React.useState<Date | null>(new Date());
  const [endDate, setEndDate] = React.useState<Date | null>(new Date());
  const [enrollstartDate, setEnrollStartDate] = React.useState<Date | null>(
    new Date()
  );
  const [gradedDesignation, setGradedDesignation] = React.useState("");
  const [enrollendDate, setEnrollEndDate] = React.useState<Date | null>(
    new Date()
  );
  const [policyEndDate, setPolicyEndDate] = React.useState<Date | null>(
    new Date()
  );
  const [policyStartDate, setPolicyStartDate] = React.useState<Date | null>(
    new Date()
  );
  const [deductible, setDeductible] = React.useState("");

  const [empGradeData, setEmpGradeData] = useState<
    Array<{
      sum_insured: string;
      emp_count: string;
      deleteable: boolean;
      features: Array<string>;
    }>
  >([{ sum_insured: "", emp_count: "", deleteable: false, features: [] }]);
  // for scrolling
  const organizationDetails = useRef(null);
  const products = useRef(null);
  const plantype = useRef(null);
  const paymenttype = useRef(null);
  const EmployeeDetails = useRef(null);
  const premiumdetails = useRef(null);
  const attatchments = useRef(null);
  const emailsection = useRef(null);
  const tasks = useRef(null);
  const notes = useRef(null);
  const detailspolicy = useRef(null);

  const scrollToSection = (elementRef: any) => {
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };
  const handleClick =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };
  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };
  const [rateData, setRateData] = React.useState([
    [
      { key: "one", value: "₹ 2145" },
      { key: "two", value: "₹ 2145" },
      { key: "three", value: "₹ 2145" },
      { key: "four", value: "₹ 2145" },
      { key: "five", value: "₹ 2145" },
      { key: "six", value: "₹ 2145" },
      { key: "seven", value: "₹ 2145" },
      { key: "eight", value: "₹ 2145" },
      { key: "nine", value: "₹ 2145" },
    ],
  ]);

  const salary_bracket_data = [
    { key: "Below ₹ 1,00,000", year: "Below ₹ 1,00,000" },
    { key: "₹ 1,00,000 - ₹ 5,00,000", year: "₹ 1,00,000 - ₹ 5,00,000" },
    { key: "₹ 5,00,000 - ₹ 10,00,000", year: "₹ 5,00,000 - ₹ 10,00,000" },
    { key: "₹ 10,00,000 - ₹ 15,00,000", year: "₹ 10,00,000 - ₹ 15,00,000" },
    { key: "₹ 15,00,000 - ₹ 20,00,000", year: "₹ 15,00,000 - ₹ 20,00,000" },
    { key: "Above ₹ 20,00,000", year: "Above ₹ 20,00,000" },
  ];
  const deignation_one_data = [
    { key: "Ass. FrontEnd Developer", year: "Ass. FrontEnd Developer" },
    { key: "FrontEnd Developer", year: "FrontEnd Developer" },
    { key: "Ass. BackEnd Developer", year: "Ass. BackEnd Developer" },
    { key: "BackEnd Developer", year: "BackEnd Developer" },
  ];
  const department_one_data = [
    { key: "FrontEnd", year: "FrontEnd" },
    { key: "BackEnd", year: "BackEnd" },
    { key: "Marketing", year: "Marketing" },
    { key: "Finance", year: "Finance" },
    { key: "Corporate Communications", year: "Corporate Communications" },
  ];

  const minage_data = [
    { label: "Up to 1 Year", value: "Up to 1 Year" },
    { label: "2 Years", value: "2 Years" },
    { label: "3 Years", value: "3 Years" },
    { label: "4 Years", value: "4 Years" },
  ];
  const maxage_data = [
    { label: "Up to 1 Year", value: "Up to 1 Year" },
    { label: "2 Years", value: "2 Years" },
    { label: "3 Years", value: "3 Years" },
    { label: "4 Years", value: "4 Years" },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    if (attrName[0] === "rateData") {
      let data = rateData;
      data[attrName[1]][attrName[2]].value = value;
      setRateData([...data]);
    } else {
      let data: any = [...rateData];

      setRateData([...data]);
      if (attrName === "notes_new_data") {
        setNotesData((notesData) => [
          ...notesData,
          { name: "Umesh", date: new Date(), description: value },
        ]);
      } else {
        attrName(value);
      }
    }
  };

  const [ageData, setAgeData] = React.useState([
    [
      { key: "one", value: "10" },
      { key: "two", value: "10" },
      { key: "three", value: "10" },
      { key: "four", value: "10" },
      { key: "five", value: "10" },
      { key: "six", value: "10" },
      { key: "seven", value: "10" },
      { key: "eight", value: "10" },
      { key: "nine", value: "10" },
    ],
  ]);

  function toggleShow() {
    setShow(!show);
  }
  function toggleShowNominee() {
    setShowNominee(!showNominee);
  }
  function toggleShowhealth() {
    setShowhealth(!showhealth);
  }
  function toggleShowcorporate() {
    setShowcorporate(!showcorporate);
  }
  function toggleEnableRiders() {
    setShowEnableRiders(!showEnableRiders);
  }
  const handleClicked = () => {
    setToggle(false);
  };
  const handleClicktoogle = () => {
    setToggle(true);
  };

  const handleClickone = () => {
    setToggle(false);
  };
  const handleClicktwo = () => {
    setToggle(true);
  };
  const handleClicksuper = () => {
    setToggle(true);
  };

  const [livesinformationData, setLivesInformationData] = React.useState([
    {
      min_age: "",
      max_age: "",
      relationship: "",
      noof_lives: "",
    },
  ]);

  useEffect(() => {
    setLivesInformationData([
      {
        min_age: "19",
        max_age: "80",
        relationship: "Self",
        noof_lives: "50",
      },
      {
        min_age: "19",
        max_age: "80",
        relationship: "Spouse",
        noof_lives: "50",
      },
      {
        min_age: "0",
        max_age: "25",
        relationship: "Son",
        noof_lives: "50",
      },
      {
        min_age: "0",
        max_age: "25",
        relationship: "Daughter",
        noof_lives: "50",
      },
      {
        min_age: "19",
        max_age: "80",
        relationship: "Father",
        noof_lives: "50",
      },
      {
        min_age: "19",
        max_age: "80",
        relationship: "Mother",
        noof_lives: "50",
      },
      {
        min_age: "19",
        max_age: "80",
        relationship: "Father In Law",
        noof_lives: "50",
      },
      {
        min_age: "19",
        max_age: "80",
        relationship: "Mother In Law",
        noof_lives: "50",
      },
    ]);
  }, []);

  const locations_data = [
    { key: "Evervent- Mohali", value: "Evervent- Mohali" },
    { key: "Evervent- Mumbai", value: "Evervent- Mumbai" },
    { key: "Evervent- Jaipur", value: "Evervent- Jaipur" },
  ];

  const basicConfig_data = [
    { key: "1E+1S+1C+1C+1C+1C", value: "1E+1S+1C+1C+1C+1C" },
    { key: "1E+1S+1C+1C+1C", value: "1E+1S+1C+1C+1C" },
    { key: "1E+1S+1C+1C", value: "1E+1S+1C+1C" },
    { key: "1E+1S+1C", value: "1E+1S+1C" },
    { key: "1E+1S", value: "1E+1S" },
    { key: "1E", value: "1E" },
  ];
  const indvConfig_data = [
    { key: "Nill", value: "Nill" },
    { key: "1P+1P ", value: "1P+1P " },
    { key: "1PIL+1PIL", value: "1PIL+1PIL" },
    { key: "1P+1P+1PIL+1PIL", value: "1P+1P+1PIL+1PIL" },
  ];
  const insurer_data = [
    { key: "Aditya Birla", value: "Aditya Birla" },
    { key: "Digit", value: "Digit" },
    { key: "Tata AIA", value: "Tata AIA" },
  ];
  const insureroffice_data = [
    { key: "Evervent - Mohali", value: "Evervent - Mohali" },
    { key: "Evervent - New Delhi", value: "Evervent - New Delhi" },
    { key: "Evervent - Bangluru", value: "Evervent - Bangluru" },
  ];
  const clientid_data = [
    { label: "CLT012 - Evervent", value: "CLT012 - Evervent" },
    { label: "CLT013 - Evervent", value: "CLT013 - Evervent" },
    { label: "CLT014 - Evervent", value: "CLT014 - Evervent" },
    { label: "CLT015 - Evervent", value: "CLT015 - Evervent" },
  ];
  const enrollperiod_data = [
    { key: "15 Days", value: "15 Days" },
    { key: "30 Days", value: "30 Days" },
    { key: "45 Days", value: "45 Days" },
    { key: "60 Days", value: "60 Days" },
    { key: "90 Days", value: "90 Days" },
  ];
  const graceperiod_data = [
    { key: "5 Days", value: "5 Days" },
    { key: "6 Days", value: "6 Days" },
    { key: "7 Days", value: "7 Days" },
    { key: "8 Days", value: "8 Days" },
    { key: "9 Days", value: "9 Days" },
    { key: "10 Days", value: "10 Days" },
  ];
  const employeeEnrollmentPeriod_data = [
    { key: "15 Days", value: "15 Days" },
    { key: "30 Days", value: "30 Days" },
    { key: "45 Days", value: "45 Days" },
    { key: "60 Days", value: "60 Days" },
    { key: "90 Days", value: "90 Days" },
  ];
  const totalNumber_data = [
    { key: "4", value: "4" },
    { key: "6", value: "6" },
    { key: "5", value: "5" },
    { key: "7", value: "7" },
    { key: "3", value: "3" },
  ];
  const gradedDesignation_data = [
    { key: "SalaryBracket", value: "Salary Bracket" },
    { key: "Designation", value: "Designation" },
    { key: "Department", value: "Department" },
    { key: "Custom", value: "Custom" },
  ];
  const maximumMember_data = [
    { key: "4", value: "4" },
    { key: "6", value: "6" },
    { key: "5", value: "5" },
    { key: "7", value: "7" },
    { key: "3", value: "3" },
  ];
  const maximumNominee_data = [
    { key: "4", value: "4" },
    { key: "3", value: "3" },
    { key: "2", value: "2" },
  ];
  const cardType_data = [
    { key: "E - Card", value: "E - Card" },
    { key: "Physical Card", value: "Physical Card" },
  ];
  const healthcardIssued_data = [
    {
      key: "Per Individual Member of the Family",
      value: "Per Individual Member of the Family",
    },
    { key: "Per Employee Only", value: "Per Employee Only" },
  ];

  const add_band_for_lives = (index: number) => {
    let data = [...ageBandData];
    data.splice(index + 1, 0, { min_age: "", max_age: "" });

    setAgeBandData(data);
  };

  const remove_band_for_lives = (index: number) => {
    let data = [...ageBandData];
    data.splice(index, 1);
    setAgeBandData(data);
  };

  return (
    <Box className="layoutWrapper">
      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />
      <PostQueryForm
        attrName={setPostQueryForm}
        open_status={postQueryForm}
        value_update={updateMasterState}
      />

      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={12} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate("/homebroker?page=policies");
            }}
          >
            <ChevronLeftIcon />
          </Link>
          <div>
            <h3>Add New Policy</h3>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection h-100">
              <Link
                className={
                  sectionStatus === "organizationDetails"
                    ? "active sectionLink organizationDetails"
                    : "sectionLink organizationDetails"
                }
                onClick={() => {
                  scrollToSection(organizationDetails);
                  SetSectionStatus("organizationDetails");
                }}
              >
                <span>Organization Details</span>
              </Link>

              <Link
                className={
                  sectionStatus === "products"
                    ? "active sectionLink products"
                    : "sectionLink products"
                }
                onClick={() => {
                  scrollToSection(products);
                  SetSectionStatus("products");
                }}
              >
                <span>Poduct Type</span>
              </Link>

              <Link
                className={
                  sectionStatus === "plantype"
                    ? "active sectionLink plantype"
                    : "sectionLink plantype"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(plantype);
                  SetSectionStatus("plantype");
                }}
              >
                <span>Plan Type</span>
              </Link>

              {/* <Link
                className={
                  sectionStatus === "EmployeeDetails"
                    ? "active sectionLink EmployeeDetails"
                    : "sectionLink EmployeeDetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(EmployeeDetails);
                  SetSectionStatus("EmployeeDetails");
                }}
              >
                <span>Employee Details</span>
              </Link> */}

              <Link
                className={
                  sectionStatus === "premiumdetails"
                    ? "active sectionLink premiumdetails"
                    : "sectionLink premiumdetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(premiumdetails);
                  SetSectionStatus("premiumdetails");
                }}
              >
                <span>Premium Details</span>
              </Link>

              <Link
                className={
                  sectionStatus === "detailspolicy"
                    ? "active sectionLink detailspolicy"
                    : "sectionLink detailspolicy"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(detailspolicy);
                  SetSectionStatus("detailspolicy");
                }}
              >
                <span>Policy Details</span>
              </Link>

              {/* <Link
                className={
                  sectionStatus === "attatchments"
                    ? "active sectionLink attatchments"
                    : "sectionLink attatchments"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(attatchments);
                  SetSectionStatus("attatchments");
                }}
              >
                <span>Attatchments</span>
              </Link>

              <Link
                className={
                  sectionStatus === "emailsection"
                    ? "active sectionLink emailsection"
                    : "sectionLink emailsection"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(emailsection);
                  SetSectionStatus("emailsection");
                }}
              >
                <span>Emails</span>
              </Link>

              <Link
                className={
                  sectionStatus === "tasks"
                    ? "active sectionLink tasks"
                    : "sectionLink tasks"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(tasks);
                  SetSectionStatus("tasks");
                }}
              >
                <span>Tasks</span>
              </Link>

              <Link
                className={
                  sectionStatus === "notes"
                    ? "active sectionLink notes"
                    : "sectionLink notes"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(notes);
                  SetSectionStatus("notes");
                }}
              >
                <span>Notes</span>
              </Link> */}
            </Grid>
            <Grid xs className="rightSection h-100">
              <Box className="detailSection" sx={{ height: "70px" }}>
                <Grid container spacing={1}>
                  <Grid xs={12} className="radio_group no-border mt-3">
                    <div className="client_div">
                      <SearchDropdown
                        class_name="inputField"
                        title="Search Client ID"
                        value={clientID}
                        attrName={setClientID}
                        value_update={updateMasterState}
                        data={clientid_data}
                        warn_status={false}
                        error_message="Please select client"
                      />
                    </div>
                  </Grid>
                </Grid>
              </Box>
              {/* Organization Details */}
              <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  <Box className="detailSection mb-0" ref={organizationDetails}>
                    <div className="sectionTitle">
                      <h4>Organization Details</h4>
                    </div>
                    {/* <Grid container spacing={3}>
                      <Grid xs={12}>
                        <p className="clientsID">
                          Client ID <span>CLT23456789</span>
                        </p>
                        <p className="clientsID">
                          Parent Client ID <span>CLT23456789</span>
                        </p>
                        <p className="clientsID">
                          Parent Organization <span>CLT23456789</span>
                        </p>
                      </Grid>
                    </Grid> */}
                    <Grid container spacing={3}>
                      <Grid xs={3}>
                        <p className="companyDetails">
                          Organization<span>Evervent pvt. Ltd.</span>
                        </p>
                      </Grid>
                      <Grid xs={3}>
                        <p className="companyDetails">
                          Parent Organization <span>Private Limited</span>
                        </p>
                      </Grid>
                      <Grid xs={3}>
                        <p className="companyDetails">
                          Industry - Sub-industry
                          <span>Information Technology-Production</span>
                        </p>
                      </Grid>
                      <Grid xs={3}>
                        <p className="contactNumber">
                          <PhoneIphoneIcon />
                          +91 9876543210
                        </p>
                        <Link className="email_list" href="" target="_blank">
                          <EmailIcon />
                          www.example.com
                        </Link>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid xs={12}>
                        <MultipleSearchDropdown
                          class_name="inputField"
                          title="Locations"
                          value={locations}
                          attrName={setLocations}
                          value_update={updateMasterState}
                          multiple_data={locations_data}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              {/*Insurer Section */}
              <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  <Box className="detailSection">
                    <div className="sectionTitle">
                      <h4>Insurer Details</h4>
                    </div>
                    <Box className="insurerView">
                      <Grid container spacing={3}>
                        <Grid xs={6}>
                          <SelectDropdown
                            class_name="inputField"
                            title="Insurer"
                            value={insurerOne}
                            attrName={setInsurerOne}
                            value_update={updateMasterState}
                            dropdown_data={insurer_data}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6}>
                          <SelectDropdown
                            class_name="inputField"
                            title="Insurer Office"
                            value={insurerOffice}
                            attrName={setInsurerOffice}
                            value_update={updateMasterState}
                            dropdown_data={insureroffice_data}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              {/* Policy Case */}
              <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  <Box className="detailSection mb-0" ref={products}>
                    <div className="sectionTitle">
                      <h4>Product Type</h4>
                    </div>
                    <Grid container spacing={3}>
                      <Grid className="productTypeSection">
                        <div
                          className="radioBox productcategory"
                          onClick={() => {
                            setProductType("Term");
                          }}
                        >
                          <input
                            type="radio"
                            id="individual"
                            name="plantype"
                            defaultChecked
                            value={productType}
                          />
                          <label className="producttype grpTerm">
                            <hr />
                            Group Term Insurance
                          </label>
                        </div>
                      </Grid>
                      <Grid className="productTypeSection">
                        <div
                          className="radioBox"
                          onClick={() => {
                            setProductType("Health");
                          }}
                        >
                          <input
                            type="radio"
                            id="individual1"
                            name="plantype"
                          />
                          <label className="producttype grpHealth">
                            <hr />
                            Group Health Insurance
                          </label>
                        </div>
                      </Grid>
                      <Grid className="productTypeSection">
                        <div
                          className="radioBox"
                          onClick={() => {
                            setProductType("SuperTopup");
                          }}
                        >
                          <input
                            type="radio"
                            id="individual5"
                            name="plantype"
                          />
                          <label className="producttype grptopup">
                            <hr />
                            Group Super Topup Insurance
                          </label>
                        </div>
                      </Grid>
                      <Grid className="productTypeSection">
                        <div className="radioBox">
                          <input
                            type="radio"
                            id="individual2"
                            name="plantype"
                          />
                          <label className="producttype grpTravel">
                            <hr />
                            Group Travel Insurance
                            {/* <p>
                              A group health insurance plan provides medical
                              coverage for a group of people.
                            </p> */}
                          </label>
                        </div>
                      </Grid>
                      <Grid className="productTypeSection">
                        <div className="radioBox">
                          <input
                            type="radio"
                            id="individual3"
                            name="plantype"
                          />
                          <label className="producttype grpPA">
                            <hr />
                            Group Personal Accident
                            {/* <p>
                              That is offered to protect employees against the
                              medical expenses incurred.
                            </p> */}
                          </label>
                        </div>
                      </Grid>
                      <Grid className="productTypeSection">
                        <div className="radioBox">
                          <input
                            type="radio"
                            id="individual4"
                            name="plantype"
                          />
                          <label className="producttype grpCI">
                            <hr />
                            Group Critical Illness
                            {/* <p>
                              Group critical Illness helps employees prepare
                              financially for an unexpected life event.
                            </p> */}
                          </label>
                        </div>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
              {/* {toggle == true ? (
              <Grid container spacing={3}>
                <Grid xs={12}>
                  <h5>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Id, quibusdam?</h5>
                </Grid>
              </Grid>
              ): null} */}
              {/* Product Type */}
              <Grid container spacing={3} className="px-0">
                <Grid xs={12} lg={12} xl={6}>
                  <Box className="detailSection">
                    <div className="sectionTitle">
                      <h4>Policy Case</h4>
                    </div>
                    <Grid container spacing={3}>
                      <Grid className="PolicyTypeSection">
                        <div
                          className="radioBox policytype"
                          onClick={() => {
                            setPolicyType(0);
                          }}
                        >
                          <input
                            type="radio"
                            id="fresh"
                            name="planstype"
                            defaultChecked
                          />
                          <label className="policytype fresh">
                            <h6>Fresh Policy</h6>
                            <p>Buying policy for the first time.</p>
                          </label>
                        </div>
                      </Grid>
                      <>
                        <Grid className="PolicyTypeSection">
                          <div
                            className="radioBox"
                            onClick={() => {
                              setPolicyType(1);
                            }}
                          >
                            <input type="radio" id="renewal" name="planstype" />
                            <label className="policytype renew">
                              <h6>Renewal Policy</h6>
                              <p>Existing Policy will be expiring.</p>
                            </label>
                          </div>
                        </Grid>
                      </>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
              {/* policy history */}
              {policyType === 1 ? <PolicyHistory /> : null}

              {/* Plan Type */}
              <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  <Box className="detailSection mb-0" ref={plantype}>
                    <div className="sectionTitle">
                      <h4>Plan Type</h4>
                    </div>
                    <Grid container spacing={3}>
                      <Grid xs={4} className="planTypeSection">
                        <div className="radioBox plantype">
                          <input
                            type="radio"
                            name="radioButtonName"
                            defaultChecked
                            onClick={() => {
                              setPlanType(0);
                            }}
                          />
                          <label>
                            Flat Coverage
                            <span>
                              Common average amount for all employees in the
                              policy.
                            </span>
                          </label>
                        </div>
                      </Grid>
                      <Grid xs={4} className="planTypeSection">
                        <div className="radioBox plantype">
                          <input
                            type="radio"
                            name="radioButtonName"
                            onClick={() => {
                              setPlanType(1);
                            }}
                          />
                          <label>
                            Graded Coverage
                            <span>
                              Different average amount for different employees
                              in the policy.
                            </span>
                          </label>
                        </div>
                      </Grid>
                      {/* <Grid xs={4} className="planTypeSection">
                        <div className="radioBox plantype">
                          <input
                            type="radio"
                            name="radioButtonName"
                            onClick={() => {
                              setPlanType(2);
                            }}
                          />
                          <label>
                            Flexi
                            <span>
                              Lorem ipsum dolor sit amet this ready only text
                              here.
                            </span>
                          </label>
                        </div>
                      </Grid> */}
                      <Grid xs={12}>
                        {/* Coverage Section */}
                        {planType === 0 || planType === 1 ? (
                          <Box className="coverageDetail">
                            <Grid container spacing={3}>
                              <Grid xs={12}>
                                <h5 className="empsecHeading">
                                  Select Coverage Type
                                </h5>
                              </Grid>
                              <Grid xs={12}>
                                <ul className="coverageAmt">
                                  <li>
                                    <div className="Checkbox">
                                      <input
                                        type="checkbox"
                                        name="check"
                                        checked
                                      />
                                      <label className="employee">
                                        <p>Employee</p>
                                      </label>
                                    </div>
                                  </li>
                                  {productType !== "Term" ? (
                                    <>
                                      <li>
                                        <div className="Checkbox ">
                                          <input
                                            type="checkbox"
                                            name="check"
                                            checked
                                          />
                                          <label className="spouse">
                                            <p>Spouse</p>
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="Checkbox ">
                                          <input
                                            type="checkbox"
                                            name="check"
                                            checked
                                          />
                                          <label className="kids">
                                            <p>Kids</p>
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="Checkbox ">
                                          <input type="checkbox" name="check" />
                                          <label className="parents">
                                            <p>Parents</p>
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="Checkbox ">
                                          <input type="checkbox" name="check" />
                                          <label className="parents">
                                            <p>Parents In Law</p>
                                          </label>
                                        </div>
                                      </li>
                                    </>
                                  ) : null}
                                </ul>
                              </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                              <Grid xs={12}>
                                <h5 className="subHeading">
                                  Coverage Configuration
                                </h5>
                              </Grid>
                              {productType === "Term" ? (
                                <Grid sm={6} md={4} lg={3} xl={3}>
                                  <RKTextField
                                    class_name="inputField"
                                    title="Basic Configuration"
                                    value={basicConfigurationTerm}
                                    attrName={setBasicConfigurationTerm}
                                    value_update={updateMasterState}
                                    warn_status={false}
                                    disable
                                  />
                                </Grid>
                              ) : (
                                <Grid sm={6} md={4} lg={3} xl={3}>
                                  <SelectDropdown
                                    class_name="inputField"
                                    title="Basic Configuration"
                                    value={basicConfiguration}
                                    attrName={setBasicConfiguration}
                                    value_update={updateMasterState}
                                    dropdown_data={basicConfig_data}
                                    warn_status={false}
                                  />
                                </Grid>
                              )}
                              <Grid sm={6} md={4} lg={3} xl={3}>
                                <SelectDropdown
                                  class_name="inputField"
                                  title="Individual Configuration"
                                  value={indvConfiguration}
                                  attrName={setIndvConfiguration}
                                  value_update={updateMasterState}
                                  dropdown_data={indvConfig_data}
                                  warn_status={false}
                                />
                              </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                              {productType === "Term" ? (
                                <Grid sm={6} md={8} lg={5} xl={5}>
                                  <RKTextField
                                    class_name="inputField"
                                    title="Family Definition"
                                    value={familyDefinitionTerm}
                                    attrName={setFamilyDefinitionTerm}
                                    value_update={updateMasterState}
                                    warn_status={false}
                                  />
                                </Grid>
                              ) : (
                                <Grid sm={6} md={8} lg={5} xl={5}>
                                  <RKTextField
                                    class_name="inputField"
                                    title="Family Definition"
                                    value={familyDefinition}
                                    attrName={setFamilyDefinition}
                                    value_update={updateMasterState}
                                    warn_status={false}
                                  />
                                </Grid>
                              )}
                            </Grid>

                            {planType === 1 ? (
                              <Grid container spacing={3}>
                                <Grid xs={12}>
                                  <h5 className="subHeading">
                                    Criteria for Grade Creation
                                  </h5>
                                </Grid>
                                <Grid sm={6} md={4} lg={3} xl={3}>
                                  <SelectDropdown
                                    class_name="inputField"
                                    title="Select Criteria"
                                    value={gradedDesignation}
                                    attrName={setGradedDesignation}
                                    value_update={updateMasterState}
                                    dropdown_data={gradedDesignation_data}
                                    warn_status={false}
                                  />
                                </Grid>
                                {gradedDesignation === "Others" ? (
                                  <Grid sm={6} md={4} lg={4} xl={3}>
                                    <RKTextField
                                      class_name="inputField"
                                      title="Other - Input grade Criteria"
                                      value={othersGraded}
                                      attrName={setOthersGraded}
                                      value_update={updateMasterState}
                                      warn_status={false}
                                    />
                                  </Grid>
                                ) : null}
                              </Grid>
                            ) : null}
                          </Box>
                        ) : null}
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              {/* payment configuration */}

              <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  <Box className="detailSection mb-0" ref={paymenttype}>
                    <div className="sectionTitle">
                      <h4>Premium Payment Configuration</h4>
                    </div>
                    <div className="premium_payment_section">
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Premium Payment Type</h5>
                        </Grid>
                        <Grid xs={12} className="payment_radio_group">
                          <>
                            <RadioGroup row defaultValue="new">
                              <FormControlLabel
                                value="existing"
                                control={<Radio />}
                                label="Standard Premium"
                                onClick={handleClickone}
                              />

                              <FormControlLabel
                                // checked
                                value="new"
                                control={<Radio />}
                                label="Split Premium"
                                onClick={handleClicktwo}
                              />
                            </RadioGroup>
                          </>
                        </Grid>
                      </Grid>
                      {toggle == true ? (
                        <Grid container spacing={3}>
                          <Grid sm={12} md={12} lg={6} xl={6}>
                            <div className="payment_inner_section">
                              <RKTextField
                                class_name="inputField"
                                title="Employee"
                                value={employeePayment}
                                attrName={setEmployeePayment}
                                value_update={updateMasterState}
                                warn_status={false}
                              />
                              {productType != "Term" ? (
                                <>
                                  <RKTextField
                                    class_name="inputField"
                                    title="Spouse"
                                    value={spousePayment}
                                    attrName={setSpousePayment}
                                    value_update={updateMasterState}
                                    warn_status={false}
                                  />
                                  <RKTextField
                                    class_name="inputField"
                                    title="Kids"
                                    value={childrenPayment}
                                    attrName={setChildrenPayment}
                                    value_update={updateMasterState}
                                    warn_status={false}
                                  />
                                  <RKTextField
                                    class_name="inputField"
                                    title="Parents"
                                    value={parentsPayment}
                                    attrName={setParentsPayment}
                                    value_update={updateMasterState}
                                    warn_status={false}
                                  />
                                  <RKTextField
                                    class_name="inputField"
                                    title="Parents In Law"
                                    value={parentsinLawPayment}
                                    attrName={setParentsInLawPayment}
                                    value_update={updateMasterState}
                                    warn_status={false}
                                  />
                                </>
                              ) : null}
                            </div>
                          </Grid>
                        </Grid>
                      ) : null}
                      <Grid container spacing={3}>
                        <>
                          {toggle == false ? (
                            <Grid xs={12} className="pt-0">
                              <h6>
                                100% of the premium value will be paid by the
                                Client/Employer
                              </h6>
                            </Grid>
                          ) : null}

                          {toggle == true ? (
                            <Grid xs={12} className="pt-0">
                              <h6>
                                Define % of the premium value to be paid by the
                                employee for the respective associated
                                relationship
                              </h6>
                            </Grid>
                          ) : null}
                        </>
                      </Grid>
                    </div>
                  </Box>
                </Grid>
              </Grid>

              {/* Riders add */}

              {productType === "Term" ? (
                <Grid container spacing={3} className="px-0">
                  <Grid xs={12}>
                    <Box className="detailSection mb-0" ref={paymenttype}>
                      <div className="sectionTitle">
                        <h4>Riders</h4>
                      </div>
                      <div className="premium_payment_section">
                        <Grid container spacing={3}>
                          <Grid
                            xs={6}
                            className="switchFields"
                            display={"flex"}
                            alignItems="center"
                            sx={{ height: "70px" }}
                          >
                            <span>Enable Riders</span>
                            <input
                              type="checkbox"
                              className="switch ml-3"
                              onClick={toggleShowNominee}
                            />
                          </Grid>
                          <Grid xs={6} textAlign={"right"}>
                            <div className="actionBtns">
                              <Link
                                className="blueBtn addfile ml-1"
                                sx={{
                                  textDecoration: "none",
                                  cursor: "pointer",
                                }}
                                // onClick={() => {
                                //   add_band_for_lives(index);
                                // }}
                              >
                                Add
                              </Link>
                              {/* {index === 0 ? null : (
                                <Link
                                  className="redBtn delete ml-1"
                                  sx={{
                                    textDecoration: "none",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => remove_band_for_lives(index)}
                                />
                              )} */}
                            </div>
                          </Grid>
                        </Grid>
                        {toggle === showEnableRiders ? (
                          <Grid container spacing={3}>
                            <Grid xs>
                              <RKTextField
                                title={""}
                                value={undefined}
                                attrName={undefined}
                                value_update={updateMasterState}
                                warn_status={false}
                                class_name={""}
                              />
                            </Grid>
                            <Grid xs></Grid>
                            <Grid xs="auto"></Grid>
                          </Grid>
                        ) : null}
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              ) : null}

              <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  {planType === 0 || planType === 1 ? (
                    <>
                      <Box className="detailSection ">
                        <div className="sectionTitle">
                          <h4>Age Bands for Lives</h4>
                        </div>
                        <Box className="band_lives">
                          <Grid container spacing={3}>
                            {ageBandData.map((data, index) => (
                              <Grid sm={12} md={12} lg={6} xl={6}>
                                <h5>Age Band {index + 1}</h5>
                                <div className="bandlives_inner">
                                  <SearchDropdown
                                    class_name="inputField"
                                    title="Min Age"
                                    value={data.min_age}
                                    attrName={["setMinAge", "min_age"]}
                                    value_update={updateMasterState}
                                    data={minage_data}
                                    warn_status={false}
                                    error_message="Please select min age"
                                  />
                                  <SearchDropdown
                                    class_name="inputField"
                                    title="Max Age"
                                    value={data.max_age}
                                    attrName={["setMinAge", "max_age"]}
                                    value_update={updateMasterState}
                                    data={maxage_data}
                                    warn_status={false}
                                    error_message="Please select max age"
                                  />
                                  <div
                                    className="actionBtns"
                                    style={{ display: "flex" }}
                                  >
                                    <Link
                                      className="blueBtn addfile ml-1"
                                      sx={{
                                        textDecoration: "none",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        add_band_for_lives(index);
                                      }}
                                    />
                                    {index === 0 ? null : (
                                      <Link
                                        className="redBtn delete ml-1"
                                        sx={{
                                          textDecoration: "none",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          remove_band_for_lives(index)
                                        }
                                      />
                                    )}
                                  </div>
                                </div>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      </Box>

                      <Box className="detailSection mb-0">
                        <div className="sectionTitle">
                          <h4>Employees Details </h4>
                          {planType == 1 ? (
                            <div className="actionBtns ">
                              <Link
                                className="rounded_add_icons mr-3"
                                sx={{
                                  textDecoration: "none",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setEmpGradeData((empGradeData) => [
                                    ...empGradeData,
                                    {
                                      sum_insured: "5000",
                                      emp_count: "5",
                                      features: ["sdf", "sdfsd"],
                                      deleteable: true,
                                    },
                                  ]);
                                }}
                              >
                                Add Grade
                              </Link>
                            </div>
                          ) : null}
                        </div>
                        <Box className="employeeDetail">
                          {planType == 0 ? (
                            <Grid
                              container
                              spacing={0}
                              className=" gradedSection ml-3 mr-3 mb-4"
                            >
                              <Grid xs={12} className="pb-3">
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    {productType === "SuperTopup" ? (
                                      <p>Select Super Top-Up Sum Insured</p>
                                    ) : (
                                      <p>Select Sum Insured</p>
                                    )}
                                  </Grid>
                                  <Grid xs={8}>
                                    {gradedDesignation === "SalaryBracket" ? (
                                      <MultipleSearchDropdown
                                        class_name="inputField"
                                        title="Salary Brackets"
                                        value={salaryBracket}
                                        attrName={setSalaryBracket}
                                        value_update={updateMasterState}
                                        multiple_data={salary_bracket_data}
                                      />
                                    ) : null}
                                    {gradedDesignation === "Designation" ? (
                                      <MultipleSearchDropdown
                                        class_name="inputField"
                                        title="Designation"
                                        value={designationOne}
                                        attrName={setDesignationOne}
                                        value_update={updateMasterState}
                                        multiple_data={deignation_one_data}
                                      />
                                    ) : null}
                                    {gradedDesignation === "Department" ? (
                                      <MultipleSearchDropdown
                                        class_name="inputField"
                                        title="Department"
                                        value={departmentOne}
                                        attrName={setDepartmentOne}
                                        value_update={updateMasterState}
                                        multiple_data={department_one_data}
                                      />
                                    ) : null}
                                  </Grid>
                                  <Grid xs={12}>
                                    <ul className="coverageAmt">
                                      <li>
                                        <div className="radioBox ">
                                          <input type="radio" name="coverage" />
                                          <label>1 Lakh</label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="radioBox">
                                          <input
                                            type="radio"
                                            name="coverage"
                                            defaultChecked
                                          />
                                          <label>2 Lakhs</label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="radioBox">
                                          <input type="radio" name="coverage" />
                                          <label>3 Lakhs</label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="radioBox">
                                          <input type="radio" name="coverage" />
                                          <label>4 Lakhs</label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="radioBox">
                                          <input type="radio" name="coverage" />
                                          <label>5 Lakhs</label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="radioBox">
                                          <input type="radio" name="coverage" />
                                          <label>6 Lakhs</label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="radioBox">
                                          <input type="radio" name="coverage" />
                                          <label>7 Lakhs</label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="radioBox">
                                          <input type="radio" name="coverage" />
                                          <label>8 Lakhs</label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="radioBox">
                                          <input type="radio" name="coverage" />
                                          <label>9 Lakhs</label>
                                        </div>
                                      </li>

                                      <li>
                                        <div className="radioBox">
                                          <input type="radio" name="coverage" />
                                          <label>10 Lakhs</label>
                                        </div>
                                      </li>
                                    </ul>
                                  </Grid>
                                  {productType === "SuperTopup" ? (
                                    <Grid xs={6} className="super_topup">
                                      <h6>Deductible</h6>
                                      <div
                                        className="ml-3"
                                        style={{ width: "300px" }}
                                      >
                                        <RKTextField
                                          class_name="inputField"
                                          title="Enter value for Deductible"
                                          value={deductible}
                                          attrName={setDeductible}
                                          value_update={updateMasterState}
                                          warn_status={false}
                                        />
                                      </div>
                                    </Grid>
                                  ) : null}

                                  <Grid xs={12}>
                                    <div className="sectionsHeading">
                                      <h6>Features</h6>
                                      <div className="actionBtns ">
                                        <Link
                                          className="rounded_add_icons mr-3"
                                          sx={{
                                            textDecoration: "none",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setAddFeature(true);
                                          }}
                                        >
                                          Add
                                        </Link>
                                        <Link className="edit_btn">
                                          <img
                                            src="images/accordion_edit_icon.svg"
                                            alt=""
                                            className="edit_btn_icon"
                                          />
                                          Edit
                                        </Link>
                                      </div>
                                    </div>
                                  </Grid>
                                  <Box className="featuresDetail px-0">
                                    <Grid container spacing={3}>
                                      <Grid xs={12}>
                                        <div className="features_list">
                                          <ul>
                                            <li>
                                              Pre-existing disease
                                              <span>3 years & Above</span>
                                            </li>
                                            <li>
                                              Room Rent
                                              <span>1% of SI</span>
                                            </li>
                                            <li>
                                              Ambulance Cover
                                              <span>
                                                ₹ 2000 per Hospitalization
                                              </span>
                                            </li>
                                          </ul>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                  <Grid xs={12}>
                                    <div className="sectionsHeading">
                                      <h6>Exclusion</h6>
                                      <div className="actionBtns ">
                                        <Link
                                          className="rounded_add_icons mr-3"
                                          sx={{
                                            textDecoration: "none",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setAddExclusion(true);
                                          }}
                                        >
                                          Add
                                        </Link>
                                        <Link className="edit_btn">
                                          <img
                                            src="images/accordion_edit_icon.svg"
                                            alt=""
                                            className="edit_btn_icon"
                                          />
                                          Edit
                                        </Link>
                                      </div>
                                    </div>
                                  </Grid>
                                  <Box className="exclusionDetail px-0">
                                    <Grid container spacing={3}>
                                      <Grid xs={12}>
                                        <div className="features_list">
                                          <ul>
                                            <li>
                                              Surgeries
                                              <span>
                                                Any diagnosis of diseases /
                                                undergoing of surgery /
                                                occurrence of event, whose signs
                                                or symptoms first occur within
                                                30 days of Policy Period Start
                                                date.
                                              </span>
                                            </li>
                                            <li>
                                              Man-made Calamities
                                              <span>
                                                War, riot, strike, nuclear
                                                weapons induced hospitalisation.
                                              </span>
                                            </li>
                                            <li>
                                              Pregnancy and Child Birth
                                              <span>
                                                Treatment arising from or
                                                traceable to pregnancy and
                                                childbirth, miscarriage,
                                                abortion and its consequences.
                                              </span>
                                            </li>
                                          </ul>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                  <Grid xs={12}>
                                    <div className="sectionsHeading">
                                      <h6>Voluntary Plan</h6>
                                      <div className="actionBtns ">
                                        <Link
                                          className="rounded_add_icons mr-3"
                                          sx={{
                                            textDecoration: "none",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setSelectVoluntryPlans(true);
                                          }}
                                        >
                                          Add
                                        </Link>
                                        <Link className="edit_btn">
                                          <img
                                            src="images/accordion_edit_icon.svg"
                                            alt=""
                                            className="edit_btn_icon"
                                          />
                                          Edit
                                        </Link>
                                      </div>
                                    </div>
                                  </Grid>
                                  <Box className="voluntaryplans px-0">
                                    <Grid container spacing={3}>
                                      <Grid xs={12}>
                                        <div className="features_list">
                                          <ul>
                                            <li>
                                              Surgeries
                                              <span>
                                                Any diagnosis of diseases /
                                                undergoing of surgery /
                                                occurrence of event, whose signs
                                                or symptoms first occur within
                                                30 days of Policy Period Start
                                                date.
                                              </span>
                                            </li>
                                            <li>
                                              Man-made Calamities
                                              <span>
                                                War, riot, strike, nuclear
                                                weapons induced hospitalisation.
                                              </span>
                                            </li>
                                            <li>
                                              Pregnancy and Child Birth
                                              <span>
                                                Treatment arising from or
                                                traceable to pregnancy and
                                                childbirth, miscarriage,
                                                abortion and its consequences.
                                              </span>
                                            </li>
                                          </ul>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Grid>
                          ) : null}

                          {empGradeData.map((data, index) => (
                            <>
                              {planType == 1 ? (
                                <Accordion
                                  className="Accordion_section policy_gradeplan"
                                  onChange={handleChange("panel1")}
                                >
                                  <Grid container spacing={0}>
                                    <Grid xs={10}>
                                      <AccordionSummary
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                        style={{
                                          display: "inline-block",
                                          width: "100%",
                                          padding: "0",
                                        }}
                                      >
                                        <Typography
                                          className="title"
                                          style={{ width: "100%" }}
                                        >
                                          <Grid container spacing={3}>
                                            <Grid xs={4} className="pl-0">
                                              <p>Grade : {index + 1}</p>
                                            </Grid>
                                          </Grid>
                                        </Typography>
                                      </AccordionSummary>
                                    </Grid>
                                    <Grid
                                      xs={2}
                                      style={{
                                        alignSelf: "Center",
                                        display: "flex",
                                        justifyContent: "end",
                                        padding: "0",
                                      }}
                                    >
                                      {data.deleteable == false ? null : (
                                        <div
                                          className="text-right"
                                          style={{ alignSelf: "center" }}
                                        >
                                          <Link
                                            className="redBtn delete ml-3"
                                            underline="none"
                                            onClick={() => {
                                              setEmpGradeData((addFeature) =>
                                                empGradeData.filter(
                                                  (_, i) => i !== index
                                                )
                                              );
                                            }}
                                          >
                                            Remove
                                          </Link>
                                        </div>
                                      )}
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                        style={{ paddingRight: "0" }}
                                      >
                                        <Typography></Typography>
                                      </AccordionSummary>
                                    </Grid>
                                  </Grid>
                                  <AccordionDetails style={{ padding: "0" }}>
                                    <Grid container spacing={3}>
                                      <Grid xs={4}>
                                        {productType === "SuperTopup" ? (
                                          <p>Select Super Top-Up Sum Insured</p>
                                        ) : (
                                          <p>Select Sum Insured</p>
                                        )}
                                      </Grid>
                                      <Grid xs={8}>
                                        {gradedDesignation ===
                                        "SalaryBracket" ? (
                                          <MultipleSearchDropdown
                                            class_name="inputField"
                                            title="Salary Brackets"
                                            value={salaryBracket}
                                            attrName={setSalaryBracket}
                                            value_update={updateMasterState}
                                            multiple_data={salary_bracket_data}
                                          />
                                        ) : null}
                                        {gradedDesignation === "Designation" ? (
                                          <MultipleSearchDropdown
                                            class_name="inputField"
                                            title="Designation"
                                            value={designationOne}
                                            attrName={setDesignationOne}
                                            value_update={updateMasterState}
                                            multiple_data={deignation_one_data}
                                          />
                                        ) : null}
                                        {gradedDesignation === "Department" ? (
                                          <MultipleSearchDropdown
                                            class_name="inputField"
                                            title="Department"
                                            value={departmentOne}
                                            attrName={setDepartmentOne}
                                            value_update={updateMasterState}
                                            multiple_data={department_one_data}
                                          />
                                        ) : null}
                                      </Grid>
                                      <Grid xs={12}>
                                        <ul className="coverageAmt">
                                          <li>
                                            <div className="radioBox ">
                                              <input
                                                type="radio"
                                                name="coverage"
                                              />
                                              <label>1 Lakh</label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="radioBox">
                                              <input
                                                type="radio"
                                                name="coverage"
                                                defaultChecked
                                              />
                                              <label>2 Lakhs</label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="radioBox">
                                              <input
                                                type="radio"
                                                name="coverage"
                                              />
                                              <label>3 Lakhs</label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="radioBox">
                                              <input
                                                type="radio"
                                                name="coverage"
                                              />
                                              <label>4 Lakhs</label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="radioBox">
                                              <input
                                                type="radio"
                                                name="coverage"
                                              />
                                              <label>5 Lakhs</label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="radioBox">
                                              <input
                                                type="radio"
                                                name="coverage"
                                              />
                                              <label>6 Lakhs</label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="radioBox">
                                              <input
                                                type="radio"
                                                name="coverage"
                                              />
                                              <label>7 Lakhs</label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="radioBox">
                                              <input
                                                type="radio"
                                                name="coverage"
                                              />
                                              <label>8 Lakhs</label>
                                            </div>
                                          </li>
                                          <li>
                                            <div className="radioBox">
                                              <input
                                                type="radio"
                                                name="coverage"
                                              />
                                              <label>9 Lakhs</label>
                                            </div>
                                          </li>

                                          <li>
                                            <div className="radioBox">
                                              <input
                                                type="radio"
                                                name="coverage"
                                              />
                                              <label>10 Lakhs</label>
                                            </div>
                                          </li>
                                        </ul>
                                      </Grid>

                                      {productType === "SuperTopup" ? (
                                        <Grid xs={6} className="super_topup">
                                          <h6>Deductible</h6>
                                          <div
                                            className="ml-3"
                                            style={{ width: "300px" }}
                                          >
                                            <RKTextField
                                              class_name="inputField"
                                              title="Enter value for Deductible"
                                              value={deductible}
                                              attrName={setDeductible}
                                              value_update={updateMasterState}
                                              warn_status={false}
                                            />
                                          </div>
                                        </Grid>
                                      ) : null}
                                    </Grid>

                                    <Grid xs={12}>
                                      <div className="sectionsHeading">
                                        <h6>Features</h6>
                                        <div className="actionBtns ">
                                          <Link
                                            className="rounded_add_icons mr-3"
                                            sx={{
                                              textDecoration: "none",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              setAddFeature(true);
                                            }}
                                          >
                                            Add
                                          </Link>
                                          <Link className="edit_btn">
                                            <img
                                              src="images/accordion_edit_icon.svg"
                                              alt=""
                                              className="edit_btn_icon"
                                            />
                                            Edit
                                          </Link>
                                        </div>
                                      </div>
                                    </Grid>
                                    <Grid xs={12}>
                                      <Box className="featuresDetail px-0 mx-0">
                                        <Grid container spacing={3}>
                                          <Grid xs={12}>
                                            <div className="features_list">
                                              <ul>
                                                <li>
                                                  Pre-existing disease
                                                  <span>3 years & Above</span>
                                                </li>
                                                <li>
                                                  Room Rent
                                                  <span>1% of SI</span>
                                                </li>
                                                <li>
                                                  Ambulance Cover
                                                  <span>
                                                    ₹ 2000 per Hospitalization
                                                  </span>
                                                </li>
                                              </ul>
                                            </div>
                                          </Grid>
                                        </Grid>
                                      </Box>
                                    </Grid>
                                    <Grid xs={12}>
                                      <div className="sectionsHeading">
                                        <h6>Exclusion</h6>
                                        <div className="actionBtns ">
                                          <Link
                                            className="rounded_add_icons mr-3"
                                            sx={{
                                              textDecoration: "none",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              setAddExclusion(true);
                                            }}
                                          >
                                            Add
                                          </Link>
                                          <Link className="edit_btn">
                                            <img
                                              src="images/accordion_edit_icon.svg"
                                              alt=""
                                              className="edit_btn_icon"
                                            />
                                            Edit
                                          </Link>
                                        </div>
                                      </div>
                                    </Grid>
                                    <Grid xs={12}>
                                      <Box className="exclusionDetail px-0 mx-0">
                                        <Grid container spacing={3}>
                                          <Grid xs={12}>
                                            <div className="features_list">
                                              <ul>
                                                <li>
                                                  Surgeries
                                                  <span>
                                                    Any diagnosis of diseases /
                                                    undergoing of surgery /
                                                    occurrence of event, whose
                                                    signs or symptoms first
                                                    occur within 30 days of
                                                    Policy Period Start date.
                                                  </span>
                                                </li>
                                                <li>
                                                  Man-made Calamities
                                                  <span>
                                                    War, riot, strike, nuclear
                                                    weapons induced
                                                    hospitalisation.
                                                  </span>
                                                </li>
                                                <li>
                                                  Pregnancy and Child Birth
                                                  <span>
                                                    Treatment arising from or
                                                    traceable to pregnancy and
                                                    childbirth, miscarriage,
                                                    abortion and its
                                                    consequences.
                                                  </span>
                                                </li>
                                              </ul>
                                            </div>
                                          </Grid>
                                        </Grid>
                                      </Box>
                                    </Grid>
                                    <Grid xs={12}>
                                      <div className="sectionsHeading">
                                        <h6>Voluntary Plan</h6>
                                        <div className="actionBtns ">
                                          <Link
                                            className="rounded_add_icons mr-3"
                                            sx={{
                                              textDecoration: "none",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              setSelectVoluntryPlans(true);
                                            }}
                                          >
                                            Add
                                          </Link>
                                          <Link className="edit_btn">
                                            <img
                                              src="images/accordion_edit_icon.svg"
                                              alt=""
                                              className="edit_btn_icon"
                                            />
                                            Edit
                                          </Link>
                                        </div>
                                      </div>
                                    </Grid>
                                    <Grid xs={12}>
                                      <Box className="voluntaryplans px-0 mx-0 mb-2">
                                        <Grid container spacing={3}>
                                          <Grid xs={12}>
                                            <div className="features_list">
                                              <ul>
                                                <li>
                                                  Surgeries
                                                  <span>
                                                    Any diagnosis of diseases /
                                                    undergoing of surgery /
                                                    occurrence of event, whose
                                                    signs or symptoms first
                                                    occur within 30 days of
                                                    Policy Period Start date.
                                                  </span>
                                                </li>
                                                <li>
                                                  Man-made Calamities
                                                  <span>
                                                    War, riot, strike, nuclear
                                                    weapons induced
                                                    hospitalisation.
                                                  </span>
                                                </li>
                                                <li>
                                                  Pregnancy and Child Birth
                                                  <span>
                                                    Treatment arising from or
                                                    traceable to pregnancy and
                                                    childbirth, miscarriage,
                                                    abortion and its
                                                    consequences.
                                                  </span>
                                                </li>
                                              </ul>
                                            </div>
                                          </Grid>
                                        </Grid>
                                      </Box>
                                    </Grid>
                                  </AccordionDetails>
                                </Accordion>
                              ) : null}
                            </>
                          ))}
                        </Box>
                      </Box>
                    </>
                  ) : planType === 1 || planType === 2 ? (
                    <Box className="detailSection mb-0" ref={EmployeeDetails}>
                      <div className="sectionTitle">
                        <h4>Employees Details</h4>
                        <div className="actionBtns ">
                          <Link
                            className="rounded_add_icons mr-3"
                            sx={{
                              textDecoration: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setEmpGradeData((empGradeData) => [
                                ...empGradeData,
                                {
                                  sum_insured: "5000",
                                  emp_count: "5",
                                  features: ["sdf", "sdfsd"],
                                  deleteable: true,
                                },
                              ]);
                            }}
                          >
                            Add Grade
                          </Link>
                          <p className="lives">
                            Total Lives - <span> 300</span>
                          </p>
                        </div>
                      </div>
                      <Box className="employeeDetail">
                        {empGradeData.map((data, index) => (
                          <Accordion
                            className="Accordion_section gradedSection gradepadding"
                            onChange={handleChange("panel1")}
                          >
                            <Grid container spacing={0}>
                              <Grid xs={4} className="px-0">
                                <AccordionSummary
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                  style={{
                                    display: "inline-block",
                                    width: "110px",
                                  }}
                                >
                                  <Typography
                                    className="title"
                                    style={{ width: "150px" }}
                                  >
                                    <h5>Grade {index + 1} :-</h5>
                                  </Typography>
                                </AccordionSummary>
                              </Grid>
                              <Grid
                                xs={8}
                                style={{
                                  alignSelf: "Center",
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                <h4>Grade {index + 1} Lives - 150</h4>
                                {data.deleteable == false ? null : (
                                  <div
                                    className="text-right"
                                    style={{ alignSelf: "center" }}
                                  >
                                    <Link
                                      className="redBtn delete ml-3"
                                      underline="none"
                                      onClick={() => {
                                        setEmpGradeData((addFeature) =>
                                          empGradeData.filter(
                                            (_, i) => i !== index
                                          )
                                        );
                                      }}
                                    >
                                      Remove
                                    </Link>
                                  </div>
                                )}
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                >
                                  <Typography></Typography>
                                </AccordionSummary>
                              </Grid>
                            </Grid>

                            <AccordionDetails style={{ padding: "0" }}>
                              <Grid container spacing={0}>
                                <Grid xs={12} className="pb-3">
                                  <Grid container spacing={3}>
                                    <Grid
                                      xs={3}
                                      style={{ alignSelf: "center" }}
                                    >
                                      <p>Select Sum Insured</p>
                                    </Grid>
                                    <Grid xs={9}>
                                      <UGEmailInput
                                        class_name="inputField"
                                        title="Designation"
                                        value={locations}
                                        attrName={setLocations}
                                        value_update={updateMasterState}
                                        warn_status={false}
                                      />
                                    </Grid>
                                    <Grid xs={12}>
                                      <ul className="coverageAmt">
                                        <li>
                                          <div className="radioBox ">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>1 Lakh</label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                              defaultChecked
                                            />
                                            <label>2 Lakhs</label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>3 Lakhs</label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>4 Lakhs</label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>5 Lakhs</label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>6 Lakhs</label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>7 Lakhs</label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>8 Lakhs</label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>9 Lakhs</label>
                                          </div>
                                        </li>

                                        <li>
                                          <div className="radioBox">
                                            <input
                                              type="radio"
                                              name="coverage"
                                            />
                                            <label>10 Lakhs</label>
                                          </div>
                                        </li>
                                      </ul>
                                    </Grid>
                                    <Grid xs={12} className="px-0">
                                      <Grid container spacing={3}>
                                        <Grid xs={12} className="GradedLives">
                                          <p>Enter Lives Count</p>
                                          <p>
                                            Lives - <span>300</span>
                                          </p>
                                        </Grid>
                                      </Grid>
                                      <Grid container spacing={3}>
                                        <Grid xs={6} xl={3}>
                                          <RKTextField
                                            class_name="inputField"
                                            title="Employee (18-80 yrs)"
                                            value={employeeAge}
                                            attrName={setEmployeeAge}
                                            value_update={updateMasterState}
                                            warn_status={false}
                                          />
                                        </Grid>
                                        <Grid xs={6} xl={3}>
                                          <RKTextField
                                            class_name="inputField"
                                            title="Spouse (18-80 yrs)"
                                            value={spouseAge}
                                            attrName={setSpouseAge}
                                            value_update={updateMasterState}
                                            warn_status={false}
                                          />
                                        </Grid>
                                        <Grid xs={6} xl={3}>
                                          <RKTextField
                                            class_name="inputField"
                                            title="Son (0-30 yrs)"
                                            value={sonAge}
                                            attrName={setSonAge}
                                            value_update={updateMasterState}
                                            warn_status={false}
                                          />
                                        </Grid>
                                        <Grid xs={6} xl={3}>
                                          <RKTextField
                                            class_name="inputField"
                                            title="Daughter (0-30 yrs)"
                                            value={daughterAge}
                                            attrName={setDaughterAge}
                                            value_update={updateMasterState}
                                            warn_status={false}
                                          />
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid xs={12}>
                                      <div className="sectionsHeading">
                                        <h6>Features</h6>
                                        <div className="actionBtns ">
                                          <Link
                                            className="rounded_add_icons mr-3"
                                            sx={{
                                              textDecoration: "none",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              setAddFeature(true);
                                            }}
                                          >
                                            Add
                                          </Link>
                                          <Link className="edit_btn">
                                            <img
                                              src="images/accordion_edit_icon.svg"
                                              alt=""
                                              className="edit_btn_icon"
                                            />
                                            Edit
                                          </Link>
                                        </div>
                                      </div>
                                    </Grid>
                                    <Box className="featuresDetail px-0">
                                      <Grid container spacing={3}>
                                        <Grid xs={12}>
                                          <div className="features_list">
                                            <ul>
                                              <li>
                                                Pre-existing disease
                                                <span>3 years & Above</span>
                                              </li>
                                              <li>
                                                Room Rent
                                                <span>1% of SI</span>
                                              </li>
                                              <li>
                                                Ambulance Cover
                                                <span>
                                                  ₹ 2000 per Hospitalization
                                                </span>
                                              </li>
                                            </ul>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </Box>
                                    <Grid xs={12}>
                                      <div className="sectionsHeading">
                                        <h6>Exclusion</h6>
                                        <div className="actionBtns ">
                                          <Link
                                            className="rounded_add_icons mr-3"
                                            sx={{
                                              textDecoration: "none",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              setAddExclusion(true)
                                            }
                                          >
                                            Add
                                          </Link>
                                          <Link className="edit_btn">
                                            <img
                                              src="images/accordion_edit_icon.svg"
                                              alt=""
                                              className="edit_btn_icon"
                                            />
                                            Edit
                                          </Link>
                                        </div>
                                      </div>
                                    </Grid>
                                    <Box className="exclusionDetail px-0">
                                      <Grid container spacing={3}>
                                        <Grid xs={12}>
                                          <div className="features_list">
                                            <ul>
                                              <li>
                                                Surgeries
                                                <span>
                                                  Any diagnosis of diseases /
                                                  undergoing of surgery /
                                                  occurrence of event, whose
                                                  signs or symptoms first occur
                                                  within 30 days of Policy
                                                  Period Start date.
                                                </span>
                                              </li>
                                              <li>
                                                Man-made Calamities
                                                <span>
                                                  War, riot, strike, nuclear
                                                  weapons induced
                                                  hospitalisation.
                                                </span>
                                              </li>
                                              <li>
                                                Pregnancy and Child Birth
                                                <span>
                                                  Treatment arising from or
                                                  traceable to pregnancy and
                                                  childbirth, miscarriage,
                                                  abortion and its consequences.
                                                </span>
                                              </li>
                                            </ul>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </Box>
                                    <Grid xs={12}>
                                      <div className="sectionsHeading">
                                        <h6>Voluntary Plan</h6>
                                        <div className="actionBtns ">
                                          <Link
                                            className="rounded_add_icons mr-3"
                                            sx={{
                                              textDecoration: "none",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              setAddFeature(true);
                                            }}
                                          >
                                            Add
                                          </Link>
                                          <Link className="edit_btn">
                                            <img
                                              src="images/accordion_edit_icon.svg"
                                              alt=""
                                              className="edit_btn_icon"
                                            />
                                            Edit
                                          </Link>
                                        </div>
                                      </div>
                                    </Grid>
                                    <Box className="voluntaryplans px-0">
                                      <Grid container spacing={3}>
                                        <Grid xs={12}>
                                          <div className="features_list">
                                            <ul>
                                              <li>
                                                Surgeries
                                                <span>
                                                  Any diagnosis of diseases /
                                                  undergoing of surgery /
                                                  occurrence of event, whose
                                                  signs or symptoms first occur
                                                  within 30 days of Policy
                                                  Period Start date.
                                                </span>
                                              </li>
                                              <li>
                                                Man-made Calamities
                                                <span>
                                                  War, riot, strike, nuclear
                                                  weapons induced
                                                  hospitalisation.
                                                </span>
                                              </li>
                                              <li>
                                                Pregnancy and Child Birth
                                                <span>
                                                  Treatment arising from or
                                                  traceable to pregnancy and
                                                  childbirth, miscarriage,
                                                  abortion and its consequences.
                                                </span>
                                              </li>
                                            </ul>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </Box>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                        ))}
                      </Box>
                    </Box>
                  ) : null}
                  <SelectFeature
                    open_status={addFeature}
                    attrName={setAddFeature}
                    value_update={updateMasterState}
                  />
                  <Exclusion
                    open_status={Addexclusion}
                    attrName={setAddExclusion}
                    value_update={updateMasterState}
                  />
                  <SelectvoluntryPlans
                    open_status={selectvoluntryPlans}
                    attrName={setSelectVoluntryPlans}
                    value_update={updateMasterState}
                  />
                </Grid>
              </Grid>

              {/* hide this section  */}
              {/* <Box className="detailSection">
                <div className="sectionTitle">
                  <h4>Lives Information</h4>
                  <div className="total_lives">
                    <p>
                      300 <span>Total Lives</span>
                    </p>
                  </div>
                </div>
                <div className="policy_lives">
                  <Grid container spacing={3}>
                    <Grid sm={12} md={8} lg={8} xl={9}>
                      {planType === 1 ? (
                        <ul className="coverageAmt">
                          <li>
                            <div className="radioBox ">
                              <input type="radio" name="coverages" />
                              <label>Grade 1</label>
                            </div>
                          </li>
                          <li>
                            <div className="radioBox">
                              <input type="radio" name="coverages" />
                              <label>Grade 2</label>
                            </div>
                          </li>
                          <li>
                            <div className="radioBox">
                              <input
                                type="radio"
                                name="coverages"
                                defaultChecked
                              />
                              <label>Grade 3</label>
                            </div>
                          </li>
                          <li>
                            <div className="radioBox">
                              <input type="radio" name="coverages" />
                              <label>Grade 4</label>
                            </div>
                          </li>
                          <li>
                            <div className="radioBox">
                              <input type="radio" name="coverages" />
                              <label>Grade 5</label>
                            </div>
                          </li>
                        </ul>
                      ) : null}
                    </Grid>

                    <Grid sm={12} md={2} lg={2} xl={1}>
                      {planType === 1 ? (
                        <RKTextField
                          class_name="inputField"
                          title="Grade 1 Lives"
                          value={spouseAge}
                          attrName={setSpouseAge}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      ) : null}
                    </Grid>

                    <Grid sm={12} md={2} lg={2} xl={2}>
                      <SelectDropdown
                        class_name="inputField"
                        title="Sum Insured"
                        value={sumInsuredOne}
                        attrName={setSumInsuredOne}
                        value_update={updateMasterState}
                        dropdown_data={sumInsuredOne_data}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={12}>
                      <div className="table">
                        <div className="age-table">
                          <ul className="heading">
                            <li>0 - 18 yrs</li>
                            <li>19 yrs - 35 yrs</li>
                            <li>36 yrs - 45 yrs</li>
                            <li>46 yrs - 55 yrs</li>
                            <li>56 yrs - 60 yrs</li>
                            <li>61 yrs - 65 yrs</li>
                            <li>66 yrs - 70 yrs</li>
                            <li>71 yrs - 75 yrs</li>
                            <li>76 yrs - 80 yrs</li>
                          </ul>

                          {ageData.map((agemainData, agemainIndex) => (
                            <ul className="subheading">
                              {agemainData.map((agesubData, agesubIndex) => (
                                <li>
                                  <RKTextField
                                    class_name="inputField"
                                    title=""
                                    value={agesubData.value}
                                    attrName={[
                                      "ageData",
                                      agemainIndex,
                                      agesubIndex,
                                      agesubData.key,
                                    ]}
                                    value_update={updateMasterState}
                                    warn_status={false}
                                  />
                                </li>
                              ))}
                            </ul>
                          ))}
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Box> */}
              {/* premium Details */}
              <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  <Box className="detailSection mb-0">
                    <div className="sectionTitle">
                      <h4>Premium Details</h4>
                    </div>
                    <Grid container spacing={3}>
                      <Grid xs={4}>
                        <RKTextField
                          class_name="inputField"
                          title="Net Premium"
                          value={netpremium}
                          attrName={setNetPremium}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4}>
                        <RKTextField
                          class_name="inputField"
                          title="Tax @ 18%"
                          value={tax}
                          attrName={setTax}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4}>
                        <RKTextField
                          class_name="inputField"
                          title="Gross Premium"
                          value={grosspremium}
                          attrName={setGrossPremium}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
              {/* PolicyDetails */}
              <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  <Box className="detailSection mb-0" ref={detailspolicy}>
                    <div className="sectionTitle">
                      <h4>Policy Details</h4>
                    </div>
                    <Grid container spacing={3}>
                      <Grid xs={4}>
                        <DatePicker
                          class_name="inputField"
                          title="Policy Start Date"
                          value={policyStartDate}
                          attrName={setPolicyStartDate}
                          value_update={updateMasterState}
                          error_message="Please enter start Date"
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4}>
                        <DatePicker
                          class_name="inputField"
                          title="Policy End Date"
                          value={policyEndDate}
                          attrName={setPolicyEndDate}
                          value_update={updateMasterState}
                          error_message="Please enter End Date"
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4}>
                        <RKTextField
                          class_name="inputField"
                          title="CD Balance"
                          value={cDBalance}
                          attrName={setCDBalance}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
              {/* Plan Settings */}
              <Grid container spacing={3} className="px-0 ">
                <Grid xs={12}>
                  <Box
                    className="detailSection lastsection"
                    ref={detailspolicy}
                  >
                    <div className="sectionTitle">
                      <h4>Plans Settings</h4>
                    </div>
                    <Grid container spacing={3}>
                      <Grid xs={4}>
                        <RKTextField
                          class_name="inputField"
                          title="Critical CD Balance Amount"
                          value={cDBalance}
                          attrName={setCDBalance}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4}>
                        <RKTextField
                          class_name="inputField"
                          title="Critical CD Balance - % of CD Balance"
                          value={cDBalancePercent}
                          attrName={setCDBalancePercent}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4}>
                        <DatePicker
                          class_name="inputField"
                          title="Enrolment Start Date"
                          value={enrollstartDate}
                          attrName={setEnrollStartDate}
                          value_update={updateMasterState}
                          error_message="Please enter Start Date"
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid xs={4}>
                        <DatePicker
                          class_name="inputField"
                          title="Enrolment End Date"
                          value={enrollendDate}
                          attrName={setEnrollEndDate}
                          value_update={updateMasterState}
                          error_message="Please enter End Date"
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4}>
                        <RKTextField
                          class_name="inputField"
                          title="Enrolment Peroid"
                          value={enrolmentPeriod}
                          attrName={setEnrolmentPeriod}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4}>
                        <SelectDropdown
                          class_name="inputField"
                          title="Grace Period"
                          value={gracePeriod}
                          attrName={setGracePeriod}
                          value_update={updateMasterState}
                          dropdown_data={graceperiod_data}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid xs={4}>
                        <SelectDropdown
                          class_name="inputField"
                          title="Maximum Members per Family"
                          value={maximunMembers}
                          attrName={setMaximunMembers}
                          value_update={updateMasterState}
                          dropdown_data={maximumMember_data}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4}>
                        <SelectDropdown
                          class_name="inputField"
                          title="Total Members per Family"
                          value={totalNumbers}
                          attrName={setTotalNumbers}
                          value_update={updateMasterState}
                          dropdown_data={totalNumber_data}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4}>
                        <SelectDropdown
                          class_name="inputField"
                          title="New Employee Enrolment Period"
                          value={employeeenrollmentPeriod}
                          attrName={setEmployeeEnrollmentPeriod}
                          value_update={updateMasterState}
                          dropdown_data={employeeEnrollmentPeriod_data}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid
                        xs={6}
                        className="switchFields"
                        display={"flex"}
                        alignItems="center"
                        sx={{ height: "70px" }}
                      >
                        <span>Nomination</span>
                        <input
                          type="checkbox"
                          className="switch ml-3"
                          onClick={toggleShowNominee}
                        />

                        {toggle == showNominee ? (
                          <div className="ml-2" style={{ width: "300px" }}>
                            <SelectDropdown
                              class_name="inputField"
                              title="Maximum No. of Nominee"
                              value={maximumNominee}
                              attrName={setMaximumNominee}
                              value_update={updateMasterState}
                              dropdown_data={maximumNominee_data}
                              warn_status={false}
                            />
                          </div>
                        ) : null}
                      </Grid>
                      <Grid
                        xs={6}
                        className="switchFields"
                        display={"flex"}
                        alignItems="center"
                        sx={{ height: "70px" }}
                      >
                        <span>Health Card</span>
                        <input
                          type="checkbox"
                          className="switch ml-3"
                          onClick={toggleShowhealth}
                        />

                        {toggle == showhealth ? (
                          <div className="ml-2" style={{ width: "300px" }}>
                            <SelectDropdown
                              class_name="inputField"
                              title="Card Type"
                              value={cardType}
                              attrName={setCardType}
                              value_update={updateMasterState}
                              dropdown_data={cardType_data}
                              warn_status={false}
                            />
                          </div>
                        ) : null}
                      </Grid>
                      <Grid xs={12} className="px-0">
                        <Grid container spacing={3}>
                          <Grid sm={12} md={7} lg={4}>
                            <SelectDropdown
                              class_name="inputField"
                              title="Health Card Issued"
                              value={healthcardIssued}
                              attrName={setHealthCardIssued}
                              value_update={updateMasterState}
                              dropdown_data={healthcardIssued_data}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={2}></Grid>
                          <Grid
                            sm={12}
                            md={8}
                            lg={6}
                            className="switchFields"
                            display={"flex"}
                            alignItems="center"
                            sx={{ height: "70px" }}
                          >
                            <span>Corporate Buffer</span>
                            <input
                              type="checkbox"
                              className="switch ml-3"
                              onClick={toggleShowcorporate}
                            />
                            {toggle == showcorporate ? (
                              <div className="ml-2" style={{ width: "350px" }}>
                                <RKTextField
                                  class_name="inputField"
                                  title="Corporate Buffer Value"
                                  value={corporatebufferValue}
                                  attrName={setCorporateBufferValue}
                                  value_update={updateMasterState}
                                  warn_status={false}
                                />
                              </div>
                            ) : null}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              {/* Rate for Addition/Deletion per life */}

              {/* hide this section  */}
              {/* <Box className="detailSection">
                <div className="sectionTitle">
                  <h4>Rate for Addition/Deletion per life on Pro-Rata Basis</h4>
                  <div className="total_lives">
                    <p>
                      300 <span>Total Lives</span>
                    </p>
                  </div>
                </div>
                <div className="policy_lives">
                  <Grid container spacing={3}>
                    <Grid sm={12} md={8} lg={8} xl={10}>
                      {planType === 1 ? (
                        <ul className="coverageAmt">
                          <li>
                            <div className="radioBox ">
                              <input type="radio" name="coverages" />
                              <label>Grade 1</label>
                            </div>
                          </li>
                          <li>
                            <div className="radioBox">
                              <input type="radio" name="coverages" />
                              <label>Grade 2</label>
                            </div>
                          </li>
                          <li>
                            <div className="radioBox">
                              <input
                                type="radio"
                                name="coverages"
                                defaultChecked
                              />
                              <label>Grade 3</label>
                            </div>
                          </li>
                          <li>
                            <div className="radioBox">
                              <input type="radio" name="coverages" />
                              <label>Grade 4</label>
                            </div>
                          </li>
                          <li>
                            <div className="radioBox">
                              <input type="radio" name="coverages" />
                              <label>Grade 5</label>
                            </div>
                          </li>
                        </ul>
                      ) : null}
                    </Grid>

                    <Grid sm={12} md={4} lg={4} xl={2}>
                      <SelectDropdown
                        class_name="inputField"
                        title="Sum Insured"
                        value={sumInsuredOne}
                        attrName={setSumInsuredOne}
                        value_update={updateMasterState}
                        dropdown_data={sumInsuredOne_data}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={12}>
                      <div className="table">
                        <div className="rate-table">
                          <ul className="heading">
                            <li>0 - 18 yrs</li>
                            <li>19 yrs - 35 yrs</li>
                            <li>36 yrs - 45 yrs</li>
                            <li>46 yrs - 55 yrs</li>
                            <li>56 yrs - 60 yrs</li>
                            <li>61 yrs - 65 yrs</li>
                            <li>66 yrs - 70 yrs</li>
                            <li>71 yrs - 75 yrs</li>
                            <li>76 yrs - 80 yrs</li>
                          </ul>

                          {rateData.map((mainData, mainIndex) => (
                            <ul className="subheading">
                              {mainData.map((subData, subIndex) => (
                                <li>
                                  <RKTextField
                                    class_name="inputField"
                                    title=""
                                    value={subData.value}
                                    attrName={[
                                      "rateData",
                                      mainIndex,
                                      subIndex,
                                      subData.key,
                                    ]}
                                    value_update={updateMasterState}
                                    warn_status={false}
                                  />
                                </li>
                              ))}
                            </ul>
                          ))}
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Box> */}

              {/* Attatchment Section */}
              {/* <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  <Box className="detailSection mb-0" ref={attatchments}>
                    <div className="sectionTitle">
                      <h4>Attachments </h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => setUploadFile(true)}
                        >
                          Add Document
                        </Link>
                      </div>
                    </div>

                   

                    <Attachment
                      open_status={attachment}
                      attrName={setAttachment}
                      value_update={updateMasterState}
                    />
                
                  </Box>
                </Grid>
              </Grid> */}
              {/* Email Section */}
              {/* <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  <Box className="detailSection mb-0" ref={emailsection}>
                    <div className="sectionTitle">
                      <h4>Emails </h4>
                      <div className="actionBtns">
                        <Link
                          className="redBtn delete"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Delete
                        </Link>

                        <Link
                          className="blueBtn edit"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Compose
                        </Link>
                      </div>
                    </div>

                   

                    <EmailComponent
                      open_status={emailcomp}
                      attrName={setEmailComp}
                      value_update={updateMasterState}
                    />
                  
                  </Box>
                </Grid>
              </Grid> */}
              {/* Task Section */}
              {/* <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  <Box className="detailSection mb-0" ref={tasks}>
                    <div className="sectionTitle">
                      <h4>Tasks </h4>
                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Add Task
                        </Link>
                      </div>
                    </div>
                    <div className="mx-3">
                      <TasksSection />
                    </div>
                  </Box>
                </Grid>
              </Grid> */}
              {/* Notes Section */}
              {/* <Grid container spacing={3} className="px-0">
                <Grid xs={12}>
                  <Box className="detailSection" ref={notes}>
                    <div className="sectionTitle">
                      <h4>Notes</h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => {
                            setPostQueryForm(true);
                          }}
                        >
                          Add Notes
                        </Link>
                      </div>
                    </div>

                    <NotesSection data={notesData} />
                  </Box>
                </Grid>
              </Grid> */}
            </Grid>

            {/* Footer Section */}
            <Grid container spacing={3} className="footerSection">
              <Grid xs={12} className="ctaBtn">
                <Button variant="outlined" className="borderBtn">
                  Cancel
                </Button>

                <Button
                  variant="contained"
                  className="submitBtn"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default AddNewPolicy;
